import $ from "jquery";
import {active} from "./const.js";

$('#js-fixedCtaCloseButton').on('click', (event) => {
  $('#js-fixedCta').fadeOut();

  return false;
});
